import styled from "styled-components";
import { device } from "../../stylesheet/breakpoints";

export const Thumb = styled.div`
  min-width: 80px;
  width: 100%;
  min-height: 40px;
  padding: 8px 14px;
  background: var(--bg-button);
  border-radius: 3px;

  &.progressArticle {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    width: 100%;
    border-radius: 0;

    & > p:first-child {
      /* width: 54px; */
      margin-right: 6px;
      font-size: 25px;
    }

    & > p:last-child {
      width: 140px;
      font-size: 10px;
      line-height: 1.2;
    }
  }

  @media ${device.desktop} {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    min-width: 140px;
    max-width: 210px;
    min-height: 50px;
    height: 50px;
    padding: 10px;
  }
`;

export const Text = styled.p`
  margin-right: 6px;
  text-align: start;
  font-weight: 700;
  font-size: 15px;
  line-height: 1.2;
  color: var(--button-text-color);

  @media ${device.desktop} { 
    font-size: 25px;
  }
`;

export const TextSecond = styled.p`
  text-align: start;
  font-weight: 500;
  font-size: 9px;
  line-height: 1.125;
  color: var(--button-text-color);

  @media ${device.desktop} {
    font-size: 10px;
    line-height: 1.2;
  }
`;
